import React from 'react';
import { MESSAGE_ARTIFACT_REPORT, MESSAGE_ARTIFACT_REPORT_CALLCENTER } from '@/shared/config';
import { auth } from '@/shared/lib';
import { NormalButton, NoDataComponent } from '@/shared/ui';
import PDFLoading from '../pdfLoading/pdfLoading';
import CanNotAccessReportIcon from './assets/images/can-not-access-report-icon.svg';
import './pdfViewer.s.scss';

// `type` isn't a valid <iframe> attribute — pre-existing no-op. Using a typed
// tag-name reference (renders the same real <iframe>) avoids a JSX prop spread.
const IframeWithType: any = 'iframe';

export type PDFViewerProps = {
  isLoading: boolean;
  url: string;
  isArtifactReport: boolean;
  isDisabledGenerateReport: boolean;
  isRendering?: boolean;
  reportStatus?: string;
  isFailedDownloadReport?: boolean;
  handleButtonClick?: (isRetry: boolean) => void;
};

const PDFViewer = ({
  isLoading,
  url,
  isArtifactReport,
  isDisabledGenerateReport,
  isRendering,
  reportStatus,
  isFailedDownloadReport,
  handleButtonClick = () => {},
}: PDFViewerProps) => {
  const alreadyHasReport = reportStatus === 'Generated' || reportStatus === 'Ready';

  return (
    <div className="pdf-viewer pa3">
      {isLoading || isRendering ? (
        <PDFLoading isRendering={isRendering} />
      ) : !url && !isArtifactReport ? (
        alreadyHasReport ? (
          isFailedDownloadReport ? (
            <div className="phi-pdf-report-container">
              <img src={CanNotAccessReportIcon} alt="Can not access report icon" />
              <div>Something went wrong! Try reloading</div>
              <div>
                <NormalButton
                  id="phi-retry-report-btn"
                  buttonName="Retry"
                  onClick={() => {
                    handleButtonClick(true);
                  }}
                />
              </div>
            </div>
          ) : (
            <div className="phi-pdf-report-container">
              <img src={CanNotAccessReportIcon} alt="Can not access report icon" />
              <div>You must regenerate the report to access it.</div>
              <div>
                <NormalButton
                  id="phi-generate-report-btn"
                  buttonName="Generate Report"
                  onClick={() => {
                    handleButtonClick(false);
                  }}
                  disabled={isDisabledGenerateReport}
                />
              </div>
            </div>
          )
        ) : (
          <NoDataComponent />
        )
      ) : !!url && !isArtifactReport ? (
        <IframeWithType
          id="pdf-viewer"
          title="PDF file"
          src={encodeURI(url)}
          type="application/pdf"
          width="100%"
          height="100%"
        />
      ) : (
        <NoDataComponent
          message={
            isArtifactReport
              ? auth.isCallCenter()
                ? MESSAGE_ARTIFACT_REPORT_CALLCENTER
                : MESSAGE_ARTIFACT_REPORT
              : undefined
          }
        />
      )}
    </div>
  );
};

export default PDFViewer;
